<template>
  <div class="logistics">
    <div class="logistics_nav">
      <navbar
        title="选择物流公司"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        :righticonshow="true"
        :righticon="righticon"
        @rightclick="toSearch"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-row class="show_logistics_row">
            <van-col
              span="24"
              class="show_logistics"
              v-for="(item, index) in list"
              :key="index"
            >
              <img class="icon" :src="item.logo" />
              {{ item.name }}
              <img
                v-if="selectItem && selectItem.id == item.id"
                class="select"
                src="../../../assets/purchaseSupplier/common/select.png"
              />
              <img
                v-if="selectItem.id != item.id"
                @click="select(item)"
                class="select"
                src="../../../assets/purchaseSupplier/common/no_select.png"
              />
            </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-row class="submit_btn">
      <van-col span="24">
        <btn
          :btntext="'确定'"
          :btnwidth="'34.3rem'"
          :height="'5rem'"
          :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
          :borderradius="'0.4rem'"
          :btncolor="'#fff'"
          :fontsize="'1.8rem'"
          :fontweight="700"
          @btnClick="submit"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      righticon: require("@/assets/purchaseSupplier/common/search.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      selectItem: {},
      searchVal: "",
    };
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.searchVal = localStorage.getItem("searchVal");
    localStorage.removeItem("searchVal");
    this.getExpress();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    select(item) {
      this.selectItem = item;
    },
    toSearch() {
      // localStorage.setItem("nowList", JSON.stringify(this.list));
      this.$router.push({
        path: "/purchaseSupplier/logisticsSearch",
      });
    },
    submit() {
      localStorage.setItem("selectAddress", JSON.stringify(this.selectItem));
      this.$router.go(-1);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getExpress();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getExpress();
    },
    getExpress() {
      let parm = {};
      if (this.searchVal) {
        parm = {
          page: this.page,
          size: 50,
          name: this.searchVal,
        };
      } else {
        parm = {
          page: this.page,
          size: 50,
        };
      }
      this.$api
        .post("/platformsys/member/express/logistics/list", parm)
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.logistics {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .logistics_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #ffffff;
    z-index: 3;
    box-shadow: 0 0 0.8rem 0 rgba(153, 153, 153, 0.2);
  }

  .box {
    padding: 8.8rem 0 8.2rem;
    box-sizing: border-box;
    height: 100%;
    background: #fff;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .show_logistics_row {
      min-height: 8.1rem;
      background: #fff;
      padding: 0 1.6rem;
      box-sizing: border-box;

      .show_logistics {
        color: #333;
        font-size: 1.9rem;
        font-weight: 700;
        height: 8rem;
        line-height: 8rem;
        padding: 0 1rem;
        background: #fff;
        text-align: left;
        border-bottom: solid 0.05rem #ccc;
        box-sizing: border-box;

        .icon {
          width: 4rem;
          vertical-align: middle;
          margin-right: 2.2rem;
        }

        .select {
          float: right;
          width: 1.8rem;
          margin-top: 3.1rem;
        }
      }
    }
  }

  .submit_btn {
    padding: 1.6rem;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
  }
}
</style>